import { define } from 'wicked-elements'
import PhotoSwipe from 'photoswipe/dist/photoswipe.js'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js'

define('[data-component~="lightbox"]', {
  init() {
    this.gid = this.element.dataset.gid // gallery id
    if (!this.gid) return

    this.thumbElements = [...document.querySelectorAll(`[data-zoom="${this.gid}"]`)]
    this.imgElements = this.thumbElements.map($el => $el.querySelector('img'))
    this.$pswp = document.querySelector('.pswp')
    this.$measure = document.querySelector('.folder__scroll-wrap-measure')
    this.$sidebar = this.$pswp.querySelector('.folder__sidebar')
    this.$overview = this.$pswp.querySelector('.folder__sidebar__overview')
    this.$caption = this.$pswp.querySelector('.folder__sidebar__caption')
    this.$close = this.$pswp.querySelector('.folder__sidebar-button--close')
    this.$prev = this.$pswp.querySelector('.folder__sidebar-button--prev')
    this.$next = this.$pswp.querySelector('.folder__sidebar-button--next')
    this.$counter = [...this.$pswp.querySelectorAll('.folder__counter')]
    this.$nav = this.$pswp.querySelector('.folder__sidebar__nav')

    this.pswp = null

    this.items = this.thumbElements.map(el => {
      let data = {
        el: el,
        src: el.dataset.src,
        w: parseInt(el.dataset.width, 10),
        h: parseInt(el.dataset.height, 10),
        title: el.getAttribute('data-caption'),
        description: el.getAttribute('data-description'),
      }
      return data
    })

    this.handleFigureClick = this.handleFigureClick.bind(this)
    this.handleCloseClick = this.handleCloseClick.bind(this)
    this.handlePrevClick = this.handlePrevClick.bind(this)
    this.handleNextClick = this.handleNextClick.bind(this)
    this.handleWheel = this.handleWheel.bind(this)
  },
  connected () {
    if (this.gid) {
      this.thumbElements.forEach(el => {
        const $img = el.querySelector('img')
        $img.addEventListener('click', this.handleFigureClick)
      })
      this.hashInit()
    }
  },
  disconnected () {
    if (this.gid) {
      this.thumbElements.forEach(el => {
        const $img = el.querySelector('img')
        $img.removeEventListener('click', this.handleFigureClick)
      })
      this.pswp && this.pswp.destroy()
    }
  },
  bindCustomUiEvents () {
    this.$close.addEventListener('click', this.handleCloseClick)
    this.$next.addEventListener('click', this.handleNextClick)
    this.$prev.addEventListener('click', this.handlePrevClick)
    this.$sidebar.addEventListener('wheel', this.handleWheel, true)
    this.$sidebar.addEventListener('mousewheel', this.handleWheel, true)
    this.$sidebar.addEventListener('DOMMouseScroll', this.handleWheel, true)
  },
  unbindCustomUiEvents () {
    this.$close.removeEventListener('click', this.handleCloseClick)
    this.$next.removeEventListener('click', this.handleNextClick)
    this.$prev.removeEventListener('click', this.handlePrevClick)
    this.$sidebar.removeEventListener('wheel', this.handleWheel, true)
    this.$sidebar.removeEventListener('mousewheel', this.handleWheel, true)
    this.$sidebar.removeEventListener('DOMMouseScroll', this.handleWheel, true)
  },
  handleFigureClick (e) {
    e.preventDefault()

    // get index of slide
    // const index = this.thumbElements.indexOf(e.currentTarget)
    const index = this.imgElements.indexOf(e.currentTarget)
    
    // open gallery
    this.open(index)
  },
  handleCloseClick () {
    this.pswp.close()
  },
  handlePrevClick () {
    this.pswp.prev()
  },
  handleNextClick () {
    this.pswp.next()
  },
  handleWheel (e) {
    e.stopPropagation()
  },
  hashInit () {
    const hash = window.location.hash.substring(1)
    const hashParams = new URLSearchParams(hash)
    const gid = hashParams.get('gid')
    const pid = parseInt(hashParams.get('pid'), 10)
    if (!gid || !pid) return
    
    // get index from hash
    const index = pid - 1  
    if (gid === this.gid && this.thumbElements[index]) {
      this.open(index)
    }
  },
  open (index) {
    if (window.innerWidth >= 1024) {
      this.openDesktop(index)
    } else {
      this.openMobile(index)
    }
  },
  openMobile (index) {
    this.pswp = new PhotoSwipe(this.$pswp, PhotoSwipeUI_Default, this.items, {
      index: index,
      galleryUID: this.gid,
      showHideOpacity: true,
      barsSize: { top: 60, bottom: 'auto' },
      closeEl: true,
      captionEl: true,
      fullscreenEl: false,
      zoomEl: false,
      shareEl: false,
      counterEl: false,
      arrowEl: true,
      preloaderEl: false,
      addCaptionHTMLFn: (item, captionEl, isFake) => {
        captionEl.children[0].innerHTML = item.title || ''
        const counterContent = `<span class="inline-counter">${this.pswp.getCurrentIndex() + 1} / ${this.pswp.options.getNumItemsFn()}</span>`

        if (captionEl.children[0].firstChild) {
          const firstChildHtml = captionEl.children[0].firstChild.innerHTML
          captionEl.children[0].firstChild.innerHTML = counterContent + firstChildHtml
        } else {
          captionEl.children[0].innerHTML = counterContent
        }
        
        return true;
      },
    })

    this.pswp.listen('afterChange', () => {
      this.$counter.forEach($el => {
        $el.innerHTML = `${this.pswp.getCurrentIndex() + 1} / ${this.pswp.options.getNumItemsFn()}`  
      })
    })

    this.pswp.init()
  },
  openDesktop (index) {
    this.pswp = new PhotoSwipe(this.$pswp, PhotoSwipeUI_Default, this.items, {
      index: index,
      galleryUID: this.gid,
      showHideOpacity: false,
      hideAnimationDuration: 0, 
      showAnimationDuration: 0,
      closeOnScroll: false,
      barsSize: { top: 0, bottom: 0 },
      closeEl:false,
      captionEl: false,
      fullscreenEl: false,
      zoomEl: false,
      shareEl: false,
      counterEl: false,
      arrowEl: false,
      preloaderEl: false,
    })

    /* Makes zoom to origin continue work, since we offset our wrapper for the sidebar */
    this.pswp.listen('updateScrollOffset', _offset => {
      var r = this.$measure.getBoundingClientRect()
      _offset.x += r.left
      _offset.y += r.top
    })

    this.pswp.listen('afterChange', () => {
      this.$caption.innerHTML = this.pswp.currItem.title || ''

      // insert counter in front of caption
      if (this.element.dataset.overview && (this.pswp.options.getNumItemsFn() > 1) && this.pswp.currItem.title) {
        try {
          this.$caption.children[0].setAttribute('data-index', this.pswp.getCurrentIndex() + 1)
        } catch (e) { }
      }

      this.$counter.forEach($el => {
        $el.innerHTML = `${this.pswp.getCurrentIndex() + 1} / ${this.pswp.options.getNumItemsFn()}`
      })
    })

    this.bindCustomUiEvents()

    this.pswp.listen('destroy', () => {
      this.unbindCustomUiEvents()
    })

    if (this.items.length <= 1) {
      this.$nav.classList.add('hidden')
    } else {
      this.$nav.classList.remove('hidden')
    }

    this.$overview.innerHTML = this.element.dataset.overview || ''

    this.pswp.init()
  }
})